import styled from '@emotion/styled';

const Separator = styled('div')(({ theme }) => ({
  borderBottom: `0.1rem solid ${theme.colors.gray['300']}`,
}));

export default Separator;
